import { takeLatest, select } from 'redux-saga/effects';
import { chatModuleInstanceSelector } from '../selectors';
import chatConsts from '../constants';

function* bumpActivityWorker(action) {
  const state = yield select();
  const chatModuleInstance = chatModuleInstanceSelector(state);
  const channelId = action.payload;
  const circle = chatModuleInstance.getCircle(channelId);

  if (circle) circle.bumpActivity();
}

export default function* bumpActivitySaga() {
  yield takeLatest([chatConsts.BUMP_ACTIVITY], bumpActivityWorker);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/bumpActivity.js